import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
// Externals
import PropTypes from "prop-types";
import React from "react";
import './styles.scss';
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  content: {
    marginTop: "1rem",
    textAlign: "center",
  },
  image: {
    display: "inline-block",
    marginTop: "50px",
    maxWidth: "100%",
    width: "554px",
  },
}));

const NotFound500 = (props) => {
  const classes = useStyles();
  const history = useHistory()
  return (
    <div className={classes.root}>
      <div className="message">
        <h1>500</h1>
        <h3>Server Internal Error</h3>
        <h2>It's not you, it's me.</h2>
        <Button onClick={() => history.push("/")}>Please Go Back</Button>
      </div>

    </div>
  );
};

NotFound500.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(NotFound500);
